import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AllSearchResultsFilterablesGQL } from 'src/app/app.query.generated';
import { Locale, Qualification, SharrySelection } from 'src/types/graphql';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Injectable({ providedIn: 'root' })
export class SearchResultsFilterablesService {
  filterables: {
    users: Partial<Qualification>[];
  };
  userFilterableIds: string[];
  wonderSelectable: SharrySelection[] = [
    SharrySelection.WithIndex,
    SharrySelection.WithItinerary,
    SharrySelection.Territory,
  ];
  eventSelectable: SharrySelection[] = [SharrySelection.SimpleEvent];
  sharrySelectable: SharrySelection[] = [
    SharrySelection.Tour,
    SharrySelection.Experience,
    SharrySelection.Item,
    SharrySelection.Accommodation,
    SharrySelection.Rental,
  ];

  currentLang: string = 'it';

  constructor(
    private allSearchResultsFilterablesGQL: AllSearchResultsFilterablesGQL,
    @Inject(I18NEXT_SERVICE) private translateService: ITranslationService,
  ) {}

  init(lang?: string): Observable<boolean> {
    this.currentLang = lang ?? this.translateService.language ?? 'it';

    return this.allSearchResultsFilterablesGQL.fetch({ locale: this.currentLang as Locale }).pipe(
      map(r => r.data.allQualifications),
      tap(userFilterables => {
        this.filterables = { users: userFilterables };
        this.userFilterableIds = [...userFilterables].map(f => f.id);
      }),
      map(() => true),
    );
  }
}
const initFilterablesFactory =
  (searchResultsFilterablesService: SearchResultsFilterablesService, i18n: ITranslationService) =>
  (): Observable<boolean> => {
    const immediateLang = i18n.language;
    if (immediateLang) {
      return searchResultsFilterablesService.init(immediateLang);
    }
    return i18n.events.languageChanged.pipe(
      filter((l: any) => !!l),
      take(1),
      switchMap((l: string) => searchResultsFilterablesService.init(l)),
    );
  };

export const INIT_FILTERABLES_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: initFilterablesFactory,
  multi: true,
  deps: [SearchResultsFilterablesService, I18NEXT_SERVICE],
};
